export const MAIN_TEXT = `After selling, purchase Home Price Protection at a 10% 
discount* and provide it to the buyer. A win for both! Register and 
we will email you a promo code for your use after the sale.`
